
export default function ScienceProof() {
  const items = [
    {
      seq: 'science-proof-04',
      image: 'https://static.readdy.ai/image/fd4cc5ead5d87929353b34de6a5078e9/25d96de0b9817b100ecf1aadae20d08a.png',
      tag: '창의인지검사',
      title: '창의 인지능력 분석 테스트',
      desc: '아이의 창의 인지능력&nbsp; 발달 수준을 체계적으로 측정하고, 개인별 학습 역량을 극대화하는 맞춤 설계 시스템',
      color: 'from-violet-400 to-pink-400',
      badge: 'bg-violet-100 text-violet-700',
    },
    {
      seq: 'science-proof-03',
      image: 'https://static.readdy.ai/image/fd4cc5ead5d87929353b34de6a5078e9/e4a75d3b47b9ecd46450be17fe11c1b0.jpeg',
      tag: '인성태도검사',
      title: '창의인성·태도 정성평가 시스템',
      desc: "결과가 아닌 '참여 과정' 속 행동과 태도를 분석하는 성장 중심 평가 시스템",
      color: 'from-teal-400 to-green-500',
      badge: 'bg-teal-100 text-teal-700',
    },
    {
      seq: 'science-proof-02',
      image: 'https://static.readdy.ai/image/fd4cc5ead5d87929353b34de6a5078e9/87330b9602f6b1193e2ae4e7940a0307.jpeg',
      tag: '창의 뮤즈검사',
      title: '창의 7뮤즈 기반 강점·약점 진단 시스템',
      desc: '아이의 창의적 성향을 7가지 뮤즈로 분석하고, 성장 방향까지 설계하는 맞춤 진단 시스템',
      color: 'from-yellow-400 to-orange-400',
      badge: 'bg-yellow-100 text-yellow-700',
    },
    {
      seq: 'science-proof-01',
      image: 'https://static.readdy.ai/image/fd4cc5ead5d87929353b34de6a5078e9/c3cb2ec628ab8252535be2e45a74352a.jpeg',
      tag: '운동검사',
      title: '심박수 기반 맞춤 운동강도 설계 시스템',
      desc: '아이의 몸 상태를 수치로 읽고, 성장에 맞춰 설계하는 과학적 창의융합 운동 시스템',
      color: 'from-orange-400 to-orange-600',
      badge: 'bg-orange-100 text-orange-600',
    },
  ];

  return (
    <section id="science-proof" className="py-12 md:py-20 lg:py-24 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* 헤더 */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            아동 성장 통합 진단 및 맞춤 설계 시스템
          </h2>
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed px-4">
            창의력 연구를 바탕으로 설계된 씽크짐만의 교육 철학을 확인하세요.
          </p>
        </div>

        {/* 카드 4개 */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {items.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* 이미지 영역 */}
              <div className="relative h-44 md:h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                {/* 번호 배지 */}
                <div className={`absolute top-3 left-3 md:top-4 md:left-4 w-8 h-8 md:w-10 md:h-10 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center shadow-lg`}>
                  <span className="text-white font-bold text-xs md:text-sm">0{index + 1}</span>
                </div>
              </div>

              {/* 텍스트 영역 */}
              <div className="p-5 md:p-6">
                <span className={`inline-block px-2 md:px-3 py-1 text-xs font-semibold rounded-full mb-2 md:mb-3 ${item.badge}`}>
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{item.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>

              {/* 하단 그라데이션 바 */}
              <div className={`h-1 w-full bg-gradient-to-r ${item.color} opacity-70 group-hover:opacity-100 transition-opacity duration-300`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
